import { render } from "./NavBox.vue?vue&type=template&id=3940f830&scoped=true"
const script = {}

import "./NavBox.vue?vue&type=style&index=0&id=3940f830&scoped=true&lang=css"

import exportComponent from "D:\\zirrowen2\\zirrowen2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3940f830"]])

export default __exports__